/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UtmDto } from './utm-dto';

/**
 * 
 * @export
 * @interface UpdateShortLinkRequestDto
 */
export interface UpdateShortLinkRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateShortLinkRequestDto
     */
    'offerId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShortLinkRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShortLinkRequestDto
     */
    'redirectUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShortLinkRequestDto
     */
    'slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShortLinkRequestDto
     */
    'type'?: UpdateShortLinkRequestDtoTypeEnum;
    /**
     * 
     * @type {UtmDto}
     * @memberof UpdateShortLinkRequestDto
     */
    'utm'?: UtmDto | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateShortLinkRequestDtoTypeEnum {
    CHECKOUT = 'checkout',
    CHECKOUT_ONE_CLICK = 'checkout_one_click',
    PRODUCT = 'product',
    PRODUCT_EXTERNAL = 'product_external',
    MEMBERS_AREA = 'members_area',
    MEMBERS_AREA_EXTERNAL = 'members_area_external',
    EXTERNAL = 'external'
}


